// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 444 ? "lang-pl" : chunkId) + "." + {"38":"1dfe7f2a","444":"a7c41616","565":"d2763bb9"}[chunkId] + ".js";
};